import { render } from "./SquashForm.vue?vue&type=template&id=04437fd6&scoped=true&ts=true"
import script from "./SquashForm.vue?vue&type=script&lang=ts"
export * from "./SquashForm.vue?vue&type=script&lang=ts"

import "./SquashForm.vue?vue&type=style&index=0&id=04437fd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04437fd6"]])

export default __exports__